module.exports = __webpack_public_path__ + "img/alerte.4177874e.svg";